import {
  LAB_UPDATE_CATEGORY,
  LAB_DELETE_CATEGORY,
  LAB_CREATE_CATEGORY,
  LAB_UPDATE_SUBCATEGORIES,
  LAB_UPDATE_CATEGORY_LOCATION,
} from '.';
import labServiceApi from '../../api/lab.service.api';
import analyticsService from 'src/helpers/analytics.service';
import { ENTITY_TYPES, EVENTS } from '../../constants';

export const updateLabCategory =
  ({ id, title, ownerIds, tags, drugClass, path }) =>
  async dispatch => {
    let res = await labServiceApi.updateCategory({ id, title, ownerIds, tags, drugClass, path });

    if (res.error) {
      return { error: res.data.message };
    }
    dispatch({
      type: LAB_UPDATE_CATEGORY,
      payload: { id, title, ownerIds, tags, drugClass, path },
    });

    return { id, title, ownerIds, tags, drugClass, path, type: res.data?.type };
  };

export const moveLabCategory =
  ({ id, categoryId, sourceId }) =>
  async dispatch => {
    let res = await labServiceApi.moveLabCategory({
      id,
      categoryId,
      sourceId,
    });

    if (res.error) {
      throw new Error(res.data.message);
    }

    analyticsService.track(EVENTS.CATEGORIES.MOVE, {
      id,
      sourceId,
      targetId: categoryId,
      type: ENTITY_TYPES.compendium,
    });

    dispatch({
      type: LAB_UPDATE_CATEGORY_LOCATION,
    });
  };

export const deleteLabCategory =
  ({ id }) =>
  async dispatch => {
    let res = await labServiceApi.deleteCategory({ id });

    if (res.error) {
      // TODO: add monitor
      return false;
    }

    dispatch({
      type: LAB_DELETE_CATEGORY,
      payload: { id },
    });
  };

export const createLabCategory =
  ({ path, title, type, ownerIds, tags, drugClass }) =>
  async (dispatch, getState) => {
    const workspaceId = getState().workspace.selected;

    let { error, data } = await labServiceApi.createCategory({
      data: {
        path,
        title,
        type,
        ownerIds,
        tags,
        drugClass,
      },
      workspaceId,
    });

    if (error) {
      return { error: data.message };
    }

    let { category } = data;

    dispatch({
      type: LAB_CREATE_CATEGORY,
      payload: {
        category,
        path,
        tags,
        drugClass,
      },
    });

    return category;
  };

export const updateLabCategorySubcategories =
  ({ id, categoryId, index }) =>
  async dispatch => {
    let res = await labServiceApi.updateCategorySubcategories({ id, categoryId, index });

    if (res.error) {
      // TODO: add monitor
      return false;
    }

    dispatch({
      type: LAB_UPDATE_SUBCATEGORIES,
      payload: { id, categoryId, index },
    });
  };
